import type { MemberRepository } from '@zetyar/data-contracts'
import { createSupabaseMemberRepository } from '@zetyar/supabase-client'
import { getSupabaseClient } from '@/infrastructure/supabase/app'

export const webMemberRepository: MemberRepository = createSupabaseMemberRepository(getSupabaseClient())
